import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "160",
  height: "115",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#F0C4E6",
      d: "M103.432 10.004 80 33.699 56.569 10.004c-12.941-13.087-33.922-13.087-46.863 0s-12.941 34.304 0 47.39l46.863 47.392c12.94 13.087 33.922 13.087 46.862 0l46.863-47.391c12.941-13.087 12.941-34.305 0-47.391-12.941-13.087-33.922-13.087-46.862 0"
    }, null, -1)
  ]))]))
}
export default { render: render }